import { createSlice } from '@reduxjs/toolkit';

import { messageCreateAction } from '@/Module/Contact/Store/Action/messageCreateAction';

const ContactUsSlice = createSlice({
  name: 'contactUs',
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(messageCreateAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(messageCreateAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(messageCreateAction.fulfilled, state => {
        state.isLoading = false;
      });
  },
});

export default ContactUsSlice;
